import { Component, OnInit } from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
// import moment from 'moment-timezone';
import * as moment from 'moment-timezone';

import {RoleServiceService} from '../../role/service/role-service.service';
import {ToastrService} from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {UserServiceService} from '../user-service/user-service.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.css']
})
export class UserFormComponent implements OnInit {
  userDetailForm: FormGroup;
  public tzNames: string[];
  roleList: any [];
  selectedRoleList: any [];
  currentPermissionList: any [];
  permissionList: any [];
  rolePermissionList = [];
  showPermission: boolean;
  clientId: any;
    index = 0;
loading = false;
submitted = false;

  constructor(private _formBuilder: FormBuilder,
              private _roleService: RoleServiceService,
              private router: Router,
              private  _userService: UserServiceService,
              private toastr: ToastrService) {
      this.getAllPermissions();
/*
      controls = this.currentPermissionList.map(c => new FormControl(false));
*/
      this.clientId = localStorage.getItem('clientId') !== undefined ? localStorage.getItem('clientId') : 'ELASTIC_CARE';

      this.tzNames = moment.tz.names();
      this.userDetailForm = this. _formBuilder.group({
          firstName: ['', Validators.required],
          lastName: ['', Validators.required],
          phoneNumberCell: ['', Validators.required],
          timeZone: ['', Validators.required],
          email: ['', Validators.required],
          userRoles: [this._formBuilder.array([]), Validators.required],
          currentPermissions: [[]],
          clientId: ['']
      });
  }

  ngOnInit() {

    this.getAllRoles();

  }

  public getAllRoles() {
    this._roleService.getAllRoles()
        .subscribe(data => {
          if (data.status === 200) {
            const response: any = data.json();
            this.roleList = response.roles;
            console.log(response.roles);
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          // this.toastr.error('', 'Please try again');
        });
  }

  public getAllPermissions() {
    this._roleService.getAllPermissions()
        .subscribe(data => {
          if (data.status === 200) {
            const response: any = data.json();
            this.permissionList = response;
            console.log(response);
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          // this.toastr.error('', 'Please try again');
        });
  }

  /*getRolePermission() {
    // this.userDetailForm.controls['currentPermissions'].setValue([]);
    console.log(this.userDetailForm.value.userRoles);
    this.selectedRoleList = this.userDetailForm.value.userRoles;
     // this.currentPermissionList = this.userDetailForm.controls['currentPermissions'].value;
    for (let i = 0 ; i < this.selectedRoleList.length; i++) {
        let currentRolePermissionList = [];
        this._roleService.getRolePermission(this.selectedRoleList[i])
          .subscribe(data => {
            if (data.status === 200) {
              const response: any = data.json();
               currentRolePermissionList = response.permissions;

                this.permissionList.forEach((o, i) => {
                    const control = new FormControl(i === 0); // if first item set to true, else false
                    (this.userDetailForm.controls.currentPermissions as FormArray).push(control);
                });
               /!*for (let i = 0 ; i < this.permissionList.length ; i ++) {
                   for (let j = 0 ; j < currentRolePermissionList.length ; j++) {
                       if (this.permissionList[i].name === currentRolePermissionList[j]) {
                            const  control = this.permissionList.map(c => new FormControl(false));
                           control[i].setValue(true);
                           (this.userDetailForm.controls.currentPermissions as FormArray).push(control[i]);
                           break;
                       } else {
                           const  control =  this.permissionList.map(c => new FormControl(false));
                           control[i].setValue(false);
                           (this.userDetailForm.controls.currentPermissions as FormArray).push(control[i]);
                           break;
                       }
                       /!*console.log(this.currentPermissionList[i]);
                       console.log();*!/
                   }
               }*!/
               // this.userDetailForm.controls['currentPermissions'].setValue(this.currentPermissionList);
              this.showPermission = true;
            } else {
              this.toastr.error('', 'Please try again');
            }
          }, (error) => {
            // this.toastr.error('', 'Please try again');
          });
    }
  }*/

    getRolePermission() {
        // this.userDetailForm.controls['currentPermissions'].setValue([]);
        console.log(this.userDetailForm.value.userRoles);
        this.selectedRoleList = this.userDetailForm.value.userRoles;
        // this.currentPermissionList = this.userDetailForm.controls['currentPermissions'].value;
        for (let i = 0 ; i < this.selectedRoleList.length; i++) {
            this.currentPermissionList = [];
            this._roleService.getRolePermission(this.selectedRoleList[i])
                .subscribe(data => {
                    if (data.status === 200) {
                        const response: any = data.json();
                        this.currentPermissionList = response.permissions;
                        this.userDetailForm.controls['currentPermissions'].setValue(this.currentPermissionList);
                        this.showPermission = true;
                    } else {
                        this.toastr.error('', 'Please try again');
                    }
                }, (error) => {
                    // this.toastr.error('', 'Please try again');
                });
        }
    }
/*
  onChange(permissionId, isChecked: boolean) {
    const control = <FormArray>this.userDetailForm.controls['currentPermissions'].value;
    if (isChecked) {
        this.userDetailForm.controls['currentPermissions'].value.push(permissionId);
    } else {
      this.userDetailForm.controls['currentPermissions'].value.pop(permissionId);
    }
  }

  inputChecked(permission) {
    this.rolePermissionList = [];
    let checked = false;
    this.rolePermissionList = this.userDetailForm.get('currentPermissions').value;
    for (let l = 0; l < this.rolePermissionList.length; l++) {
      if (this.rolePermissionList[l] === permission) {
        checked = true;
        break;
      } else {
        checked = false;
      }
    }
    return checked;
  }*/
  saveUser(userDetailsForm) {
      this.userDetailForm.controls['clientId'].setValue(this.clientId);

      this.loading = true;
      this.submitted = true;
      console.log(JSON.stringify(this.userDetailForm.value));
      this._userService.addUser(userDetailsForm.value)
          .pipe(first())
          .subscribe(data => {
              if (data.status === 200) {
                  this.toastr.success('', 'Package saved successfully');
                  this.router.navigate(['/elasticcare/user']);
                  this.loading = false;
              } else {
                  this.toastr.error('', 'Please try again');
              }
          }, (error) => {
              this.toastr.error('', 'Please try again');
              this.loading = false;
          });
  }
}
